import { useEffect, useState } from 'react';
import { WebApiModelsEmailTemplate } from '../../Repository/eventbookyapi';
import { AuthProvider } from '../../Providers/authProvider';
import { TextService } from '../../Services/TextService';
import { EmailForm } from '../../Components/Users/EmailForm';
import LeftMenuCommunicate from './LeftCommunicate';
import { EmailFormType } from '../../Types/EmailFormType';
import { EmailTemplateService } from '../../Services/EmailTemplateService';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';

const AdminSendEmailExternal = () => {
  const [emailTemplates, setEmailTemplates] = useState([] as WebApiModelsEmailTemplate[]);
  const [user, setUser] = useState({} as any);
  const GetText = TextService.GetText;

  useEffect(() => {
    AuthProvider().GetLoggedInUser().then(user => {
      setUser(user);
    });

    EmailTemplateService.GetTemplates().then(result => {
      setEmailTemplates(result);
    });

  }, []);

  return <LayoutLeftMenu title={GetText("Communicate_SendMailTitle")} menu={<LeftMenuCommunicate selected={"sendEmailExternal"} />}>
    <EmailForm user={user} enablePaymentLink={false} emailTemplates={emailTemplates} type={EmailFormType.EmailFormByExternal} />
  </LayoutLeftMenu>
};

export default AdminSendEmailExternal;